import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import ContactElement from '../ContactElement';

var Call = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Call, _React$PureComponent);

  function Call() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Call.prototype;

  _proto.getCallLink = function getCallLink() {
    var phoneNumber = this.props.phoneNumber;
    var countryCode = '1';
    var cleanPhoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return "tel:+" + countryCode + cleanPhoneNumber;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        phoneNumber = _this$props.phoneNumber,
        as = _this$props.as,
        header = _this$props.header,
        iconPosition = _this$props.iconPosition,
        showIcon = _this$props.showIcon,
        buttonColor = _this$props.buttonColor,
        className = _this$props.className,
        fluidButton = _this$props.fluidButton,
        buttonSize = _this$props.buttonSize,
        label = _this$props.label;
    return /*#__PURE__*/React.createElement(ContactElement, {
      contact: label || phoneNumber,
      link: this.getCallLink(),
      iconType: showIcon || as === 'icon' ? 'phone' : 'none',
      as: as,
      header: header,
      className: className,
      buttonColor: buttonColor,
      iconPosition: iconPosition,
      fluidButton: fluidButton,
      buttonSize: buttonSize
    });
  };

  return Call;
}(React.PureComponent);

export { Call as default };
Call.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  label: '',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false
};
Call.propOptions = {
  header: ['Call Us', ''],
  buttonColor: ['primary', 'secondary', 'default'],
  iconPosition: ['left', 'top']
};